export const pgArrayToJsArray = (pgArrayString) => {
  return pgArrayString
    .substring(1, pgArrayString.length - 1) // Remove outer curly braces
    .split(',')
    .map((item) => item.trim().replace(/^"|"$/g, ''));
};
